import { ReactNode } from 'react';
import { faChevronRight, faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Styled from 'components/onboarding-checklist/onboarding-checklist-item/styled';
import { OnboardingChecklistItemStyleProps } from 'components/onboarding-checklist/onboarding-checklist-item/types';
import styled from 'styled-components';

interface OnboardingChecklistItemProps extends OnboardingChecklistItemStyleProps {
    icon: ReactNode;
    isCompleted: boolean;
    children?: ReactNode;
    className?: string;
}

const OnboardingChecklistItemPrimitive = (props: OnboardingChecklistItemProps) => {
    const { isCompleted, children, interactive = true, icon, className = '' } = props;
    return (
        <Styled.ChecklistItemWrapper
            className={className}
            isCompleted={isCompleted}
            interactive={interactive}
        >
            <Styled.CheckableIconWrapper isCompleted={isCompleted}>
                {isCompleted ? (
                    <FontAwesomeIcon
                        icon={faCircleCheck}
                        style={{ width: '16px', height: '16px' }}
                    />
                ) : (
                    icon
                )}
            </Styled.CheckableIconWrapper>
            <Styled.ChecklistItemChildrenWrapper>{children}</Styled.ChecklistItemChildrenWrapper>
            {interactive && !isCompleted && (
                <Styled.ChecklistArrowContainer>
                    <FontAwesomeIcon icon={faChevronRight} />
                </Styled.ChecklistArrowContainer>
            )}
        </Styled.ChecklistItemWrapper>
    );
};

const OnboardingChecklistItem = styled(OnboardingChecklistItemPrimitive)``;
const OnboardingChecklistText = Styled.ChecklistItemText;

const Root = OnboardingChecklistItem;
const Text = OnboardingChecklistText;

export {
    OnboardingChecklistItem,
    OnboardingChecklistText,
    //
    Root,
    Text,
};
export type { OnboardingChecklistItemProps };
